<template>
  <div>
    <CRUDList
      ref="crudList"
      :canAdd="false"
      :headers="headers"
      :displayTopPagination="false"
      :canEdit="false"
      :canSave="false"
      :showDate="true"
      :showDialog="false"
      :canDelete="canDelete"
      :disablePagination="true"
      :hideDefaultFooter="true"
      :enableFixedHeaders="true"
      :onSingleClickOpenDialog="enableSingleClick"
      :footerTotalDisplayColumnWise="totals"
      :baseCrudKey="baseCrudKey"
      :defaultSortBy="defaultSortBy"
      :tableWrapperDynamicClassname="wrapperCss"
      :disableKeyboardFunc="disableKeyboardFunc"
      @onSingleClicked="onSingleClicked"
      @emitDeleteRowItem="deleteRowItem"
      @emitRowButtonClick="handleRowButtonClick"
      tableDynamicClassname="taxroll-custom-table"
      tableDynamicHeight="130">
    </CRUDList>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { juneResaleBottomTableHeader } from '../../deliquentUtils/deliquent.utils';
import { amountFormat } from '../../../../../util/shared/vue-global';
import CRUDList from '../../../../common/base/crud-2.0/CRUDList.vue';
import '../../../../../assets/style.css';

export default {
  name: 'ResalePropertDetailsList',
  props: {
    baseCrudKey: {
      type: String,
      default: 'baseCrudKeyForResaleDetails',
    },
    ResalePropertyBaseCrudKey: {
      type: String,
      default: 'paymentTaxTransactionList',
    },
    wrapperCss: {
      type: String,
      default: 'elevation-3 ma-3 pa-1 pb-5 taxroll-table-wrapper',
    },
    enableSingleClick: {
      type: Boolean,
      default: true,
    },
    enableTotals: {
      type: Boolean,
      default: true,
    },
    disableKeyboardFunc: {
      type: Boolean,
      default: true,
    },
    canDelete: {
      type: Boolean,
      default: false,
    },
    isItFromResalePropertyDialog: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      // headers: juneResaleBottomTableHeader,
    };
  },
  components: {
    CRUDList,
  },
  computed: {
    ...mapGetters('base/crud', ['items', 'item']),
    headers() {
      // In the Edit June Resale Record dialog the Total Fees amount is the way into that tax
      // year's fee list - add, edit and delete - the same affordance the Personal Tax Warrant
      // detail grid uses. The read-only grid under the browse has nowhere to open it, so the
      // amount stays plain text there.
      if (!this.isItFromResalePropertyDialog) return juneResaleBottomTableHeader;
      return juneResaleBottomTableHeader.map((header) => (header.value === 'totalFeesDue'
        ? { ...header, clickable: true } : header));
    },
    totals() {
      const selItems = this.item(this.ResalePropertyBaseCrudKey);
      if (this.enableTotals) {
        return [null, null, null, null, null, 'Totals:', amountFormat(selItems.mainTotalTaxDue),
          amountFormat(selItems.mainTotalPenalty), amountFormat(selItems.mainTotalFeesDue),
          amountFormat(selItems.mainTotalDue)];
      }
      return [`# ${(selItems.taxDetails || []).length} records`];
    },
    defaultSortBy() {
      return [
        {
          column: 'taxId',
          direction: 'desc',
        },
      ];
    },
  },
  methods: {
    ...mapMutations('tax/taxPayment', [
      'setSelectedItemsBelowTable',
    ]),
    onSingleClicked() {
      this.$emit('handleDialogItem');
    },
    deleteRowItem(item) {
      this.$emit('deleteRowItem', item);
    },
    handleRowButtonClick(item) {
      this.$emit('handleRowButtonClick', item);
    },
  },
};
</script>
